import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Dialog,
  DialogContent,
  DialogContentText,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useCardDetailContext } from "../../../CardDetailContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import { useQuantityContext } from "../../../QuantityContext";
import { useUserDetailContext } from "../../../UserDetailContext";
import { ReactComponent as VerifiedTick } from "../../../../Assets/img/icons/verified-tick.svg";
import loaderGif from "../../../../Assets/img/icons/Animation - 1718370478484.gif";
import { getAllCardDetailsReducer, getAllCardInfoReducer, patchProfessionalCardReducer } from "../../../../Redux/Reducers/CardReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const ProfessDetails = ({ handleSuccess, handleFailure }) => {
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };
  const dispatch = useDispatch();
  const { userDetails } = useUserDetailContext();
  const { cardDetails, updateCardDetails, ContactStyles, setContactStyles } =
    useCardDetailContext();
  const { setisNavigationBlocked, openSnackbar, handleInfo } = useQuantityContext();

  const Allcards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);

  const filteredCardName = Allcards?.filter(
    (card) =>
      card?.card_name?.toLowerCase().trim() ===
      cardDetails?.CardName?.toLowerCase().trim()
  );

  // const initialProfessionalDataRef = useRef({
  //   employee_id: cardDetails?.employee_id || "",
  //   company_id: cardDetails?.company_id || ""
  // });


  const updateContactValue = (fieldName, newValue) => {
    setContactStyles((prevState) => ({
      ...prevState,
      [fieldName]: newValue,
    }));



    updateCardDetails({ ["is_professional_verified"]: true });
  };

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;

    updateCardDetails({ [fieldName]: newValue });

  };


  const [cardNameError, setCardNameError] = useState("");
  const [SaveEnable, setSaveEnable] = useState(false);
  const [initialCardDetails, setInitialCardDetails] = useState({}); // Define initialCardDetails here
  const [professionalDataChanged, setProfessionalDataChanged] = useState(false);

  useEffect(() => {
    setInitialCardDetails(cardDetails);
  }, []);

  useEffect(() => {
    const changed = initialCardDetails.employee_id === cardDetails.employee_id && initialCardDetails.company_id === cardDetails.company_id;

    // console.log("changedchanged", changed);
    setProfessionalDataChanged(changed);
    // if (professionalDataChanged === true) {
    //   updateCardDetails({ ["is_professional_verified"]: true });
    // } else
    // if (professionalDataChanged === false) {
    //   updateCardDetails({ ["is_professional_verified"]: false });
    // }
    console.log("professionalDataChanged", professionalDataChanged);
  }, [cardDetails, initialCardDetails]);



  console.log("initialCardDetailsinitialCardDetails", initialCardDetails);

  useEffect(() => {
    setSaveEnable(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
    setisNavigationBlocked(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
  }, [cardDetails, initialCardDetails]);



  const handleSave = async (event) => {

    event.preventDefault();
    console.log("cardDetaikls", cardDetails);



    const payload = { ...cardDetails };

    console.log("PayloadPalyload", payload); // Clone the original object
    delete payload.CardName;

    if (cardDetails?.CardType === "Professional" || cardDetails?.CardType === "Customize_Professional") {
      try {
        const resolvedCardId = isNaN(cardDetails?.card_id)
          ? filteredCardName?.[0]?.id
          : cardDetails?.card_id;

        const response = await dispatch(patchProfessionalCardReducer({ id: resolvedCardId, data: payload }));
        console.log("RESPONSE IN THE Professional update", response);
        setSaveEnable(false);
        await dispatch(getAllCardDetailsReducer());
        await dispatch(getAllCardInfoReducer());
        handleSuccess();
      } catch (error) {
        console.log("API ERROR", error);
      }
    };

    // try {
    //   const response = await axios.post(
    //     `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
    //     cardDetails,
    //     {
    //       headers: headers,
    //     }
    //   );

    //   console.log("Response from backend for cards:", response);
    //   if (response?.status === 201) {
    //     setInitialCardDetails(cardDetails);
    //     handleSuccess();
    //     await dispatch(getAllCardDetailsReducer());
    //     await dispatch(getAllCardInfoReducer());
    //   }

    // } catch (error) {
    //   console.error("Error submitting card details:", error);
    //   handleFailure("It will accept only Integers.");
    // }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/card/card-contact`,
        ContactStyles,
        {
          headers: headers,
        }
      );
      console.log("Response from backend:", response.data);
      // handleSuccess();
    } catch (error) {
      console.error("Error submitting card details:", error);
      // handleFailure();
    }
  };

  const [isDialogOldEmail, setisDialogOldEmail] = useState(false);
  const [isDialogNewEmail, setisDialogNewEmail] = useState(false);

  const [emailId, setemailId] = useState(ContactStyles?.email);
  const [code, setCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showCodeError, setShowCodeError] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [showCode, setShowCode] = useState(false);
  const [isDomainVerified, setDomainVerified] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [verifyDisabled, setVerifyDisabled] = useState(false);

  const toggleCodeVisibility = () => {
    setShowCode((prev) => !prev);
  };

  const handlecloseDialog = () => {
    setCode("");
    setErrorMessage("");
    setemailId(ContactStyles?.email);
    setisDialogNewEmail(false);
    setisDialogOldEmail(false);
    setVerifyDisabled(false);
  };

  const handleCodeChange = (event) => {
    setCode(event.target.value);
    setShowCodeError(false);
    setErrorMessage("");
  };

  useEffect(() => {
    // Start the timer only when TwoFactorAuthSecondPage becomes true
    const interval = setInterval(() => {
      if (minutes === 0 && seconds === 0) {
        setCode("");
        clearInterval(interval);
      } else {
        // Decrease seconds if greater than 0
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          if (minutes > 0) {
            setMinutes(minutes - 1);
            setSeconds(59); // Reset seconds to 59 when minutes decrease
          }
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  // const SendOtpOldEmail = () => {
  //     if (!emailId) {
  //         alert("Email id is empty")
  //     }
  //     else if (emailId == ContactStyles.email) {
  //         alert("same email")
  //     }
  //     else {
  //         setisDialogOldEmail(true);
  //         setMinutes(0);
  //         setSeconds(60);
  //         axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`, {
  //             email: `${ContactStyles.email}`,
  //         }, { headers: headers })
  //             .then(response => {
  //                 console.log("OTP sent successfully");
  //             })
  //             .catch(error => {
  //                 // Handle error, such as displaying an error message to the user
  //                 console.error("Failed to send OTP:", error);
  //             });
  //     }
  // }

  // const handleCodeSubmitOldEmail = () => {
  //     axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`, {
  //         email: `${ContactStyles.email}`,
  //         otp: code,
  //     }, { headers: headers })
  //         .then(response => {
  //             setCode('');
  //             setErrorMessage('');
  //             console.log("OTP verified successfully");
  //             setisDialogOldEmail(false);
  //             setisDialogNewEmail(true);
  //             sendOtpNewEmail();
  //         })
  //         .catch(error => {
  //             setCode('');
  //             setErrorMessage("Incorrect OTP. Please try again.");
  //             console.error("Failed to verify OTP:", error);
  //         });
  // }

  const sendOtpNewEmail = () => {
    if (!emailId.includes("@") || emailId.trim() === "") {
      // alert("enter the valid email");
      setCardNameError("Enter a Valid Email");
    } else {
      setVerifyDisabled(true);
      setCardNameError("");
      SendingOTP();
    }
  };
  const trimmedEmail = emailId?.trim();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isEmailValid = emailRegex.test(trimmedEmail);

  const SendingOTP = async () => {


    // console.log("isEmailValidisEmailValid", isEmailValid);
    if (isEmailValid) {
      openSnackbar("Sending OTP to your E-mail ID...", "info", 4000);
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`,
          {
            email: `${emailId}`,
          },
          { headers: headers }
        )
        .then((response) => {
          setMinutes(0);
          setSeconds(60);
          setisDialogNewEmail(true);
          handleSuccess("OTP Sent to your E-mail ID!", 3000);
          // console.log("OTP sent successfully");
        })
        .catch((error) => {
          // Handle error, such as displaying an error message to the user
          handleFailure("Could not send OTP. Try Again.", 3000);
          console.error("Failed to send OTP:", error);
        });
    } else {
      handleInfo("Please enter a valid email address.")

      return;
    }

  };

  // const checkDomainVerification = async (email) => {
  //   setPageLoading(true);
  //   handleInfo("Please wait to complete the process.")
  //   try {
  //     const domain = email.split("@")[1];
  //     const response = await axios.get(`https://logoapi.onrender.com/logo`, {
  //       params: { domain },
  //     });

  //     // console.log("Domain Verifyed in the Edit Card", response);
  //     if (response.data) {
  //       const fetchedLogo = response.data.logo;
  //       let bloblogo;
  //       if (fetchedLogo) {
  //         const payloadlogo = {
  //           logo: fetchedLogo, // Include the logo URL
  //         };

  //         bloblogo = await axios.post(
  //           `${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url-from-url`,
  //           payloadlogo,
  //           {
  //             headers: headers,
  //           }
  //         );

  //       }
  //       // console.log("blob url", bloblogo);


  //       const payload = fetchedLogo ? { ...cardDetails, logo: bloblogo?.url } : { ...cardDetails, logo: cardDetails?.logo?.data };


  //       try {

  //         // if (fetchedLogo) {
  //         const logoResponse = await axios.post(
  //           `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
  //           payload,
  //           {
  //             headers: headers,
  //           }
  //         );
  //         if (logoResponse.status === 201)
  //           console.log("fetched LOGO", fetchedLogo);
  //         updateCardDetails({ logo: fetchedLogo });
  //         // }

  //       } catch (error) {
  //         console.log("Could not set the fetched logo:", fetchedLogo);
  //       }
  //     }

  //     if (response.data.isDomainVerified) {
  //       setDomainVerified(true);
  //       return true;
  //     }
  //     return false;
  //   } catch (error) {
  //     console.error("Failed to check domain verification:", error);
  //     return false;
  //   } finally {
  //     setPageLoading(false);
  //   }
  // };

  // const updateLogoInCard = async (email) => {
  //     try {
  //         const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/verify/update-company-logo`, {
  //             email: email,
  //             cardName: cardDetails.CardName,
  //             cardType: cardDetails.CardType
  //         }, { headers: headers });

  //     } catch (error) {
  //         console.error("Failed to check domain verification:", error);
  //     }
  //     return true;
  // }

  const handleCodeSubmitNewEmail = async () => {
    try {
      // Proceed with OTP verification
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`,
          {
            email: emailId,
            otp: code,
          },
          { headers: headers }
        )
        .then(async (response) => {
          setCode("");
          setErrorMessage("");
          setisDialogNewEmail(false);
          // const domainVerified = await checkDomainVerification(emailId);
          // console.log("checking domain:", domainVerified);
          console.log("checking response:", response);
          setProfessionalDataChanged(true);
          // if (domainVerified) {
          updateCardDetails({ professional_email_id: emailId });
          updateCardDetails({ ["is_professional_verified"]: true });
          console.log("OTP verified successfully");
          // await updateLogoInCard(emailId)
          updateContactValue("email", emailId);
          setVerifyDisabled(false);
          // }
          // else {
          //     setErrorMessage("Domain is not verified. Please use a Correct Professional email.");
          // }
        })
        .catch((error) => {
          setErrorMessage("Incorrect OTP. Please try again.");
          console.error("Failed to verify OTP:", error);
          setVerifyDisabled(false);
        });
    } catch (error) {
      console.error("Error in domain verification or OTP submission:", error);
    }
  };
  // const professinaldatachanges = cardDetails?.employee_id !== carddata?.employee_id || cardDetails?.company_id !== carddata?.company_id;







  // if (pageLoading) {
  //   return (
  //     <div className="loader-container">
  //       <img src={loaderGif} alt="Loading..." height={100} width={100} />
  //     </div>
  //   );
  // }

  return (
    <div>
      <div>
        {/* <Box className='my-4 card-info-box' sx={{ border: "1px solid #17b200", backgroundColor: "white", borderRadius: 2, paddingTop: "16px" }}> */}
        <div style={{ paddingRight: "16px", paddingLeft: "16px" }}>
          <div className="card-edit-info-heading">
            <h5>Professional Details</h5>
            <span>
              Please note that this information won't appear on the card while
              sharing
            </span>
            <p className="text-display-details">
              *Confidential information, share options not available{" "}
            </p>
          </div>

          <div className="my-2 user-details-container">
            <Grid container spacing={2}>
              {/* First Row */}
              <Grid item xs={6}>
                <TextField
                  label="Employee ID"
                  fullWidth
                  value={cardDetails?.employee_id || ""}
                  onChange={handleInputChange("employee_id")}
                  inputProps={{ maxLength: 18 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Company CIN/ UIN"
                  fullWidth
                  value={cardDetails?.company_id || ""}
                  onChange={handleInputChange("company_id")}
                  inputProps={{ maxLength: 18 }}
                />
              </Grid>

              {/* Second Row */}
              <Grid item xs={6}>
                <TextField
                  label="Professional Email ID"
                  fullWidth
                  value={emailId || ""}
                  onChange={(e) => {
                    const newEmail = e.target.value;
                    setemailId(newEmail);
                  }}
                  InputProps={{
                    maxLength: 48,
                    endAdornment: (
                      <InputAdornment position="end">
                        {cardDetails?.is_professional_verified &&
                          ContactStyles?.email === emailId && SaveEnable === false ? (
                          <VerifiedTick className="green-verified-tick" />
                        ) : (
                          <VerifiedTick />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />

                {cardNameError && (
                  <Typography variant="body2" color="error">
                    {cardNameError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6} container alignItems="center">

                {(cardDetails?.is_professional_verified && ContactStyles?.email === emailId && SaveEnable === false) ? <Button variant="contained" className="verify-button success-green" disabled>
                  Verified
                </Button> : <Button
                  variant="contained"
                  sx={{ backgroundColor: "#0044C6" }}
                  onClick={!verifyDisabled ? sendOtpNewEmail : undefined}
                // disabled={emailId === ContactStyles.email}
                >
                  Verify
                </Button>}

              </Grid>
            </Grid>

            <FormControlLabel
              control={<Switch checked={true} />}
              label="Disabled"
            />
          </div>
        </div>
        <div
          className="save-bottom"
          style={{
            textAlign: "right",
            backgroundColor: "#0044C614",
            padding: "12px",
            borderRadius: "0 0 8px 8px",
          }}
        >
          <Button
            variant="contained"
            sx={{ backgroundColor: "#0044C6" }}
            onClick={handleSave}
            disabled={!SaveEnable}
          >
            Save
          </Button>
        </div>
        <ToastContainer toastClassName="email-toast-success" />
        {/* </Box> */}
      </div>



      {isDialogNewEmail && (
        <Dialog
          open={isDialogNewEmail}
          // onClose={handleCloseVerifiedDialog}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">
                  Two-factor Authentication
                </p>
                <p className="paragraph-text">Verify your new E-mail ID</p>
                <button
                  type="button"
                  className="lightbox__close"
                  onClick={handlecloseDialog}
                >
                  &times;
                </button>
                <div>
                  <div className="">
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""
                          }`}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleCodeVisibility}>
                                {showCode ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    {errorMessage ? (
                      <div style={{ color: "red", marginTop: "10px" }}>
                        {errorMessage}
                      </div>
                    ) : (
                      <div style={{ marginTop: "10px" }}></div>
                    )}

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}
                        :{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div
                        className="next-button-container"
                        style={{ gap: "16px" }}
                      >
                        <button
                          className={`next-btn ${code.trim() === "" ? "disabled" : ""
                            }`}
                          type="submit"
                          onClick={handleCodeSubmitNewEmail}
                          disabled={code.trim() === ""}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail?{" "}
                      <button
                        className="button-style-height"
                        onClick={sendOtpNewEmail}
                      >
                        RESEND
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default ProfessDetails;
